import { useState } from "react";

export const useAmount = () => {
  const [displayValue, setDisplayValue] = useState<string>("10");

  const amount = displayValue === "" ? 1 : Number(displayValue);

  const handleChange = (val: string) => {
    if (val === "") {
      setDisplayValue("");
      return;
    }
    const num = parseInt(val, 10);
    if (!isNaN(num) && num >= 1) {
      setDisplayValue(String(num));
    }
  };

  const handleBlur = () => {
    if (displayValue === "") {
      setDisplayValue("1");
    }
  };

  const setAmount = (n: number) => setDisplayValue(String(n));

  const increase = () => setDisplayValue((v) => String(Math.min(1000, (v === "" ? 1 : Number(v)) + 1)));
  const decrease = () => setDisplayValue((v) => String(Math.max(1, (v === "" ? 1 : Number(v)) - 1)));

  return {
    amount,
    displayValue,
    handleChange,
    handleBlur,
    setAmount,
    increase,
    decrease,
  };
};
